export default __webpack_public_path__ + "static/media/logo.050c9088.png";